import { Controller } from "@hotwired/stimulus";

// Caps how many selections inside this scope can be active at once and
// gates paired write-in text inputs behind their checkbox. Once the cap
// is reached, remaining unchecked boxes are disabled; they re-enable as
// soon as the user clears one. A box can carry
// `data-vote-cap-write-in-id="<input-id>"` to indicate it controls the
// disabled state of a sibling text input.
//
// HTML wiring:
//   <div data-controller="vote-cap" data-vote-cap-max-value="6">
//     <input type="checkbox" data-vote-cap-target="box"
//            data-action="change->vote-cap#refresh">
//     <input type="checkbox" data-vote-cap-target="box"
//            data-vote-cap-write-in-id="write_in_0"
//            data-action="change->vote-cap#refresh">
//     <input type="text" id="write_in_0" disabled>
//   </div>
export default class extends Controller {
  static targets = ["box"];
  static values = { max: Number };

  connect() {
    this.refresh();
  }

  refresh() {
    const checked = this.boxTargets.filter((b) => b.checked).length;
    const atCap = checked >= this.maxValue;

    this.boxTargets.forEach((b) => {
      if (!b.checked) b.disabled = atCap;

      const writeInId = b.dataset.voteCapWriteInId;
      if (writeInId) {
        const input = document.getElementById(writeInId);
        if (input) {
          input.disabled = !b.checked;
          if (!b.checked) input.value = "";
        }
      }
    });
  }
}
